import React from "react";
import { ShiurimPageTemplate } from "themes/application/categories/pages";
import { ShiurimViewStore } from "application/categories/stores";
import { setCurrentView } from "mrb/core";

@setCurrentView((rootStore, componentProps) => new ShiurimViewStore(rootStore, componentProps), "shiurimViewStore")
class ShiurimPage extends React.Component {
    render() {
        return <ShiurimPageTemplate {...this.props} />;
    }
}

export default ShiurimPage;
